const DEFAULT_PLATFORM_DOMAIN = 'servsolo.com';

export const getPlatformDomain = () => (process.env.REACT_APP_PLATFORM_DOMAIN || DEFAULT_PLATFORM_DOMAIN).trim().toLowerCase();

export const getStoreHost = (slug) => {
  const cleanSlug = String(slug || '').trim().toLowerCase();
  if (!cleanSlug) return '';
  return `${cleanSlug}.${getPlatformDomain()}`;
};

export const getStoreOnlineUrl = (slug) => {
  const host = getStoreHost(slug);
  return host ? `https://${host}` : '';
};

export const getStoreKioskUrl = (slug) => {
  const onlineUrl = getStoreOnlineUrl(slug);
  return onlineUrl ? `${onlineUrl}/kiosk` : '';
};